/*
  ml-signup-bridge — sends the theme's Shopify-form signups to the lead API as well.

  The footer newsletter (ml-footer-index), the email drawer (monthlees-email-drawer) and the
  homepage goal-quiz modal (monthlees-modal-overlay) post to Shopify's native customer form.
  Shopify's customers/create webhook welcomes a NEW customer from that, but an existing customer
  (most of the imported audience) fires only customers/update, which the backend deliberately
  ignores, so their signup reached no ESP3 list at all.

  On each of those forms' submit this also posts { email, source[, goal] } to
  /apps/precision/lead, which tags the customer and subscribes them to the same lists the webhook
  uses (brand welcome, the goal's sequence, the newsletter audience). The native form still
  submits exactly as before, so Shopify keeps recording consent and tags; the backend's subscribe
  and the welcome's once-per-contact trigger make the double path harmless for a new customer.

  keepalive lets the request finish while a native submit navigates the page away.
*/
(function () {
  'use strict';
  if (window.__mlSignupBridge) return;
  window.__mlSignupBridge = true;

  var FORMS = [
    { selector: 'form.ml-footer-index__form', source: 'newsletter' },
    { selector: 'form.mlg-news__form', source: 'newsletter' },
    { selector: 'form.monthlees-email-drawer__form', source: 'member_intent' },
    { selector: 'form.monthlees-modal-overlay__form', source: 'goal_quiz', goal: true, defer: true }
  ];

  function post(body) {
    try {
      fetch('/apps/precision/lead', {
        method: 'POST',
        credentials: 'same-origin',
        keepalive: true,
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      }).catch(function () {});
    } catch (e) {}
  }

  function goalFrom(form) {
    var tags = form.querySelector('input[name="contact[tags]"]');
    var list = String((tags && tags.value) || '').split(',');
    for (var i = 0; i < list.length; i++) {
      var t = list[i].trim().toLowerCase();
      if (t.indexOf('goal_') === 0) return t;
    }
    return '';
  }

  function send(form, cfg) {
    var input = form.querySelector('input[name="contact[email]"]');
    var email = String((input && input.value) || '').trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) return;
    var body = { email: email, source: cfg.source };
    if (cfg.goal) {
      var g = goalFrom(form);
      if (g) body.goal = g;
    }
    post(body);
  }

  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;
      if (!form || !form.matches) return;
      for (var i = 0; i < FORMS.length; i++) {
        var cfg = FORMS[i];
        if (!form.matches(cfg.selector)) continue;
        // The goal quiz writes the chosen goal into contact[tags] in its own submit handler, which
        // runs after this capture listener, so read it on the next tick (that form never navigates).
        if (cfg.defer) window.setTimeout(function () { send(form, cfg); }, 0);
        else send(form, cfg);
        return;
      }
    },
    true
  );
})();
